import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import showElementByAuth from '~helpers/auth';
import { platformEntity, entityAction } from '~constants';
import { Empty } from 'antd';
import { getSafeHtml } from 'common/helpers/safeHtml';

export default class ContractEmpty extends React.Component {
  componentDidMount() {
    this.addListener();
  }

  addListener = () => {
    const addAction = document.querySelector('.contract-empty__click-action');
    if (addAction) {
      addAction.addEventListener('click', () => this.props.openModal());
    }
  };

  componentWillUnmount() {
    const addAction = document.querySelector('.contract-empty__click-action');
    if (addAction) {
      addAction.removeEventListener('click', () => this.props.openModal());
    }
  }

  renderContent = () => {
    const { t, typeName } = this.props;
    if (typeName === 'contract') {
      return t('cms.contract.filter.empty_content', {
        add: `<span class="contract-empty__click-action">${t(
          'cms.contract.filter.empty.add_new',
        )}</span>`,
      });
    }
    return t('cms.property.record.empty_content', {
      update: `<span class="contract-empty__click-action">${t(
        'cms.property.record.update_contract.btn',
      )}</span>`,
    });
  };

  render() {
    return (
      <div
        className={classNames('contract-empty', {
          'contract-empty__full-filter': this.props.filterState,
        })}
      >
        <Empty
          className="contract-empty__icon"
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            showElementByAuth(platformEntity.PROPERTIES_CONTRACTS, entityAction.CREATE) ? (
              <span>{getSafeHtml(this.renderContent())}</span>
            ) : (
              false
            )
          }
        />
      </div>
    );
  }
}

ContractEmpty.propTypes = {
  filterState: PropTypes.bool,
  t: PropTypes.func.isRequired,
  typeName: PropTypes.string.isRequired,
  openModal: PropTypes.func.isRequired,
};

ContractEmpty.defaultProps = {
  filterState: false,
};
